
import { Device } from '../DeviceTypes';
import { mockSmartMeters } from '@/lib/mock-data/energy/smart-meters';
import { mockVoltageRegulators } from '@/lib/mock-data/energy/voltage-regulators';
import { mapSmartMetersToDevices, mapVoltageRegulatorsToDevices } from '../utils/deviceMappers';

// Create device objects from imported smart meters for Energy department
export const energySmartMeterDevices = mapSmartMetersToDevices(mockSmartMeters, 'Energy');
export const voltageRegulatorDevices = mapVoltageRegulatorsToDevices(mockVoltageRegulators);

// Static Energy department devices
export const staticEnergyDevices: Device[] = [
  {
    id: 'ESM-2023-001',
    name: 'Energy Smart Meter 001',
    type: 'energy',
    category: 'Smart Meter',
    serial: 'ESM-2023-001',
    status: 'active',
    lastActive: '2023-10-15T10:30:00Z',
    department: 'Energy'
  },
  {
    id: 'EIG-2023-002',
    name: 'Energy IoT Gateway 002',
    type: 'energy',
    category: 'IoT Gateway',
    serial: 'EIG-2023-002',
    status: 'active',
    lastActive: '2023-10-14T16:20:00Z',
    department: 'Energy'
  },
  {
    id: 'EVR-2023-003',
    name: 'Energy Voltage Regulator 003',
    type: 'energy',
    category: 'Voltage Regulator',
    serial: 'EVR-2023-003',
    status: 'active',
    lastActive: '2023-10-16T08:45:00Z',
    department: 'Energy'
  },
  {
    id: 'EVM-2023-012',
    name: 'Energy Voltage Monitor 012',
    type: 'energy',
    category: 'Voltage Monitor',
    serial: 'EVM-2023-012',
    status: 'inactive',
    lastActive: '2023-10-10T13:25:00Z',
    department: 'Energy'
  },
  {
    id: 'ETR-2023-020',
    name: 'Energy Transformer 020',
    type: 'energy',
    category: 'Transformer',
    serial: 'ETR-2023-020',
    status: 'active',
    lastActive: '2023-10-18T11:20:00Z',
    department: 'Energy'
  },
  {
    id: 'ESW-2023-025',
    name: 'Energy Switch 025',
    type: 'energy',
    category: 'Switch',
    serial: 'ESW-2023-025',
    status: 'active',
    lastActive: '2023-10-17T15:10:00Z',
    department: 'Energy'
  },
  {
    id: 'EGS-2023-030',
    name: 'Energy Grid Sensor 030',
    type: 'energy',
    category: 'Grid Sensor',
    serial: 'EGS-2023-030',
    status: 'maintenance',
    lastActive: '2023-10-12T14:30:00Z',
    department: 'Energy'
  },
  // Additional mapped devices that were previously unmapped
  {
    id: 'ENE-34192',
    name: 'Westside Data Center',
    type: 'energy',
    category: 'Data Center',
    serial: 'ENE-34192',
    status: 'active',
    lastActive: '2023-10-19T09:15:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-47651',
    name: 'Downtown Hotel Energy System',
    type: 'energy',
    category: 'Building Management',
    serial: 'ENE-47651',
    status: 'active',
    lastActive: '2023-10-20T13:30:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-63018',
    name: 'City Convention Center',
    type: 'energy',
    category: 'Building Management',
    serial: 'ENE-63018',
    status: 'active',
    lastActive: '2023-10-18T10:45:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-92837',
    name: 'Highland Residential Complex',
    type: 'energy',
    category: 'Residential',
    serial: 'ENE-92837',
    status: 'active',
    lastActive: '2023-10-17T11:25:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-28759',
    name: 'Riverfront Manufacturing',
    type: 'energy',
    category: 'Industrial',
    serial: 'ENE-28759',
    status: 'inactive',
    lastActive: '2023-10-05T14:10:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-19384',
    name: 'Eastside Shopping Center',
    type: 'energy',
    category: 'Commercial',
    serial: 'ENE-19384',
    status: 'active',
    lastActive: '2023-10-19T16:20:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-73291',
    name: 'Summit Office Park',
    type: 'energy',
    category: 'Commercial',
    serial: 'ENE-73291',
    status: 'active',
    lastActive: '2023-10-20T09:35:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-54712',
    name: 'Valley View Apartments',
    type: 'energy',
    category: 'Residential',
    serial: 'ENE-54712',
    status: 'active',
    lastActive: '2023-10-18T12:40:00Z',
    department: 'Energy'
  },
  {
    id: 'ENE-67024',
    name: 'Central Medical Plaza',
    type: 'energy',
    category: 'Institutional',
    serial: 'ENE-67024',
    status: 'active',
    lastActive: '2023-10-19T10:55:00Z',
    department: 'Energy'
  }
];

// All energy devices combined
export const allEnergyDevices: Device[] = [
  ...staticEnergyDevices,
  ...energySmartMeterDevices,
  ...voltageRegulatorDevices
];
